module.exports = __webpack_public_path__ + "static/media/DSC_0117-2.37185199.jpg";